import script from "./Photo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Photo.vue?vue&type=script&setup=true&lang=ts"

import "./Photo.vue?vue&type=style&index=0&id=6686f323&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6686f323"]])

export default __exports__